export default "__VITE_ASSET__PDraoP0m__"